/* 
Contains usable functions for all size guide pages or modals.
Functions and variables used in asset files:
- 'size-guide-page.js'
- 'size-guide-pdp.js'
*/

"use strict";

var __sizeGuideContainersId = ['sizeMens', 'sizeWomens', 'sizeUnisex', 'sizeKids'];

/***
 * AJAX call table from pages
 */
// Parse and prepare ajax response
function parseAndAppendTable(response, gender) {

    let parser = new DOMParser();
    let responseParsed = parser.parseFromString(response, 'text/html');

    let sizeTables = responseParsed.querySelectorAll('table');

    // get sizeguide's table
    sizeTables.forEach((el, i) => document.querySelectorAll(`#${gender} .size_chart_table`)[0].appendChild(sizeTables[i]));

    // add sizeguide's table into container
    if (sizeTables.length > 0) { //Add 'is-available' class into sizeTables available
        let changeAvailabiltyInThese = [`#${gender}`, `#${gender} .size-table-container-headers`];
        changeAvailabiltyInThese.forEach(function (el, i) {
            document.querySelectorAll(el)[0].classList.remove('is-unavailable');
            document.querySelectorAll(el)[0].classList.add('is-available');
        });
    }

    if (sizeTables.length > 1) {
        sizeTables[0].classList.add('table-margin-bottom');
    }
};

/***
 * Table functions
 */
// Toggle tables
function triggerCollapsibleTables() {
    const triggerElements = document.querySelectorAll('.size-table-container-headers');
    for (let i = 0; i < triggerElements.length; i++) {
        triggerElements[i].addEventListener('click', function () {
            this.nextElementSibling.classList.toggle('is-hidden');
            this.nextElementSibling.classList.toggle('is-visible');
            this.childNodes[0].classList.toggle('active')
        });
    }
}
// Collapse all tables
function resetCollapsibleTables() {
    document.querySelectorAll('.size_chart_table').forEach((el, i) => {
        el.classList.remove('is-visible');
        el.classList.add('is-hidden');
    })
}

/***
 * Table Modal functions
 */
// Open Modal
function openSizeguideModal() {
    document.querySelector('.pdp-size-guide-modal--container').style.display = 'flex';
    document.body.classList.add('pdp-size-guide-modal-open');
}
// Clos Modal
function closeSizeguideModal(event) {
    if (event.target.classList.contains('pdp-size-guide-modal--container') || event.target.classList.contains('pdp-size-guide-modal--close')) {
        document.querySelector('.pdp-size-guide-modal--container').style.display = 'none';
        document.body.classList.remove('pdp-size-guide-modal-open');
        resetCollapsibleTables();
    }
}

// Display Modal
function showSizeguideModalButton() {
    document.getElementById('pdpSizeguideContainer').addEventListener('click', openSizeguideModal)
    document.querySelector('.pdp-size-guide-modal--container').addEventListener('click', closeSizeguideModal);

    document.getElementById('pdpSizeguideContainer').style.display = 'flex';
}
